import {CheckoutController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {ApplePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_applepay_data');

const context = new Context(getPage());

const gateway = new ApplePayGateway({
    id: 'stripe_applepay',
    settings,
    context
});

const controller = new CheckoutController({
    context,
    gateway,
    selector: '#wc-stripe_applepay-checkout-button'
});

controller.initialize();